import {
  faFileInvoice,
  faGlobe,
  faTruckFast,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

export const ACCOUNT_SUMMARY_QUICK_ACTIONS = [
  {
    id: "payroll",
    title: "Pay Payroll",
    description: "Process employee salaries",
    prompt: "Process monthly payroll for all employees",
    path: "/payroll",
    icon: faUsers,
    tone: "gold",
  },
  {
    id: "suppliers",
    title: "Free Corporate Card",
    description: "Request a physical card",
    prompt: "Pay outstanding supplier invoices",
    path: "/cardssettings",
    icon: faFileInvoice,
    tone: "violet",
  },
  {
    id: "butler",
    title: "Butler Service",
    description: "Cash pickup and delivery",
    prompt: "Request cash pickup or delivery with Butler Service",
    path: "/butlerservice",
    icon: faTruckFast,
    tone: "blue",
  },
  {
    id: "transfer",
    title: "International Transfer",
    description: "Send money abroad",
    prompt: "Send an international wire transfer",
    path: "/transferabroad",
    icon: faGlobe,
    tone: "blue",
  },
  
  
];
